import React from 'react';
import { Circle, Icon } from '@chakra-ui/react';
import { IoDiamond } from 'react-icons/io5';

interface DiamondAvatarBadgeProps {
  onClick?: () => void;
}

/**
 * Diamond mark on the creator's own profile picture — dark disc, white glyph, sitting on
 * the avatar's bottom-right corner. Expects a `position="relative"` parent.
 */
const DiamondAvatarBadge: React.FC<DiamondAvatarBadgeProps> = ({ onClick }) => (
  <Circle
    position="absolute"
    bottom="0"
    right="0"
    size="34px"
    bg="#101828"
    color="white"
    border="3px solid white"
    role="button"
    tabIndex={0}
    cursor="pointer"
    aria-label="View Diamond Tier details"
    onClick={onClick}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClick?.();
      }
    }}
  >
    <Icon as={IoDiamond} boxSize={4} />
  </Circle>
);

export default DiamondAvatarBadge;
